import { mediaUrl } from '@hbac/contract';
import { srcSetFor } from '../lib/image-variants';
import { loaders } from '../routes/lazy-pages';

let warmed = false;

/**
 * Pointing at, touching or tabbing to a link to /hbaac starts what that page
 * needs (Plan AO): its code, its header and footer, and the key visual at the
 * size its banner asks for. The page then opens complete inside the view
 * transition instead of a blank frame.
 */
export function warmHbaac(keyVisual: string | undefined): void {
  if (warmed || typeof window === 'undefined') return;
  warmed = true;
  void loaders.CompetitionPage().catch(() => undefined);
  void import('./hbaac/Chrome').catch(() => undefined);
  if (!keyVisual) return;
  const src = mediaUrl(keyVisual);
  const img = new Image();
  img.decoding = 'async';
  // The banner's own srcset and sizes (hbaac/sections.tsx, Hero), so the copy loaded is the one shown.
  img.sizes = '(min-width: 768px) 57vw, 100vw';
  const set = srcSetFor(src, [640, 1100]);
  if (set) img.srcset = set;
  img.src = src;
}
